import React from 'react'
import { DateTime } from 'luxon'

import Button from 'components/button'

interface ToolbarProps {
  currentMonth: DateTime
  onPrev: () => void
  onNext: () => void
  onToday: () => void
}

const Toolbar: React.FC<ToolbarProps> = ({ currentMonth, onPrev, onNext, onToday }) => {
  return (
    <div className="flex items-center justify-between px-4 py-2 border-b border-divider bg-surface">
      <h2 className="text-lg font-semibold text-body m-0">{currentMonth.toFormat('LLLL yyyy')}</h2>
      <div className="flex items-center rounded-lg border border-divider overflow-hidden">
        <Button
          internalType="transparent"
          onClick={onPrev}
          aria-label="Previous month"
          className="h-auto rounded-none px-3 py-1.5 border-r border-divider"
        >
          ←
        </Button>
        <Button
          internalType="transparent"
          onClick={onToday}
          className="h-auto rounded-none px-3 py-1.5 border-r border-divider font-medium"
        >
          Today
        </Button>
        <Button
          internalType="transparent"
          onClick={onNext}
          aria-label="Next month"
          className="h-auto rounded-none px-3 py-1.5"
        >
          →
        </Button>
      </div>
    </div>
  )
}

export default Toolbar
